// UI
import Box from '@/components/ui/Box'
import SKU from '@/components/ui/SKU'
import ProductionOrderImage from './ProductionOrderImage'

// Mantine
import { Anchor } from '@mantine/core'

// Dayjs
import dayjs from 'dayjs'

export default function ProductionOrderLocation({ productionOrder }) {
    return (
        <Box title="Informations">
            <div className="flex items-start justify-between gap-4">
                <div className="flex min-w-0 flex-1 flex-col gap-4">
                    <div className="flex flex-wrap items-center gap-2">
                        <SKU component={productionOrder.component} size="sm" />
                        <Anchor href={'/components/' + productionOrder.component.id}>
                            {productionOrder.component.name}
                        </Anchor>
                        <span className="text-gray-400">×{productionOrder.quantity}</span>
                    </div>

                    <div className="flex flex-col gap-2 text-sm">
                        <div className="flex items-center gap-2">
                            <span className="text-gray-500">Lieu</span>
                            <span>{productionOrder.location.name}</span>
                        </div>

                        <div className="flex items-center gap-2 text-gray-500">
                            <span>{dayjs(productionOrder.starting_at).format('LL')}</span>
                            <span>→</span>
                            <span>{dayjs(productionOrder.ending_at).format('LL')}</span>
                        </div>
                    </div>
                </div>
                <ProductionOrderImage
                    src={productionOrder.product_image}
                    name={productionOrder.component.name}
                />
            </div>
        </Box>
    )
}
